import React,{useState, useEffect} from "react";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import {toast} from 'react-toastify'
import {useForm} from 'react-hook-form'
import api from '../../../api/api'

const UserTransfer = () => {
  const [searchData, setSearchData] = useState([]);
  const { register, handleSubmit, unregister, setValue } = useForm();
  const [usersList, setUsersList] = useState([])
  const [cmpId, setCmpId] = useState(null)

    // fetch company
    useEffect(() => {
      api
        .get(`services/company/`)
        .then((response) => {
          // console.log(response.data)
          setSearchData(
            response.data.map(({ company_name: name, id }) => ({ name, id }))
          );
        })
        .catch((error) => {
          console.log(error);
        });
    }, []);


    useEffect(() => {
      api.get(`/users/?user-type=CL`)
      .then(response=> {
        // console.log(response.data)
        setUsersList(response.data)
      }).catch(error=> {
        console.log(error)
      })
    }, [])
    




    const handleOnSearch = (string, results) => {
      // onSearch will have as the first callback parameter
      // the string searched and for the second the results.
      // console.log(string, results)
    };

    const handleOnHover = (result) => {
      // the item hovered
      // console.log(result)
    };

    const handleOnSelect = (item) => {
      // the item selected
      // console.log(item);
      api
      .get(`/services/company/?id=${item.id}`)
      .then((response) => {
        // console.log("Result",response.data)
        // setResults(response.data[0]);
        setCmpId(response.data[0].id)
     
  
      })
      .catch((error) => {
        toast.error("something went wrong");
      });
    };

    const handleOnFocus = () => {
      // console.log('Focused')
    };

    const handleSub = (data) => {
      if(cmpId === null){
        toast.error("Please search company ")
        return
      }
      data.user = parseInt(data.user)

      api.patch(`/services/company/${cmpId}/user-transfer/`, data)
      .then(response=> {
        toast.success("User Transfer successfully")
      }).catch(error=> {
        toast.error("Something went wrong")
      })
    }



    const formatResult = (item) => {
      return (
        <>
          {/* <span style={{ display: 'block', textAlign: 'left' }}>id: {item.id}</span> */}
          <span style={{ display: "block", textAlign: "left" }}>{item.name}</span>
        </>
      );
    };



  return (
    <div className="px-10">
      <h1 className="text-primary-red mt-2 text-center text-3xl font-bold lg:!mt-6">
        Create User Transfer
      </h1>
      <div className="">
        <img
          src="../../images/title-border.png"
          alt=""
          className="mx-auto mt-4"
        />
      </div>

       <form onSubmit={handleSubmit(handleSub)}>
       <div className="w-72 md:w-100">
        <ReactSearchAutocomplete
        placeholder="search"
          items={searchData}
          onSearch={handleOnSearch}
          onHover={handleOnHover}
          onSelect={handleOnSelect}
          onFocus={handleOnFocus}
          autoFocus
          formatResult={formatResult}
        />
      </div>

       <div className="border-2 border-primary-red w-72 my-3 px-3 text-primary-blue">
        <label>Select User</label>
        <select className="text-primary-blue outline-none w-40"
        {...register("user", {required:false})}>

            <option>Select</option>
            {usersList.map((item, i)=> {
              return (
                <option key={i}value={item.id}>{item.profile.f_name + " "+ item.profile.l_name + item.email}</option>
              )
            })}
          

        </select>
       </div>

        <button className="bg-primary-red text-white px-3 rounded-full" type="submit">
          Submit
        </button>

       </form>



    </div>
  );
};

export default UserTransfer;
